import React from 'react'
import {
  Icon,
  Popup
} from 'semantic-ui-react'
import { format } from 'date-fns'
import { connect } from 'react-redux'
// Local
import {
  FORMAT,
  shouldRenderReskin2025
} from '../../../constant'
import * as lockUtils from '../../common/lockUtils'
import { EncounterLock } from '../../authenticated/types'
import LockOutlineIcon from './LockOutlineIcon'
import LockReveleerIcon from './LockReveleerIcon'
import { RootState } from '../../../store'

/**
 * Provides a component that renders a lock icon that reflects the state of the
 * encounter lock and current user permissions
 * @param lock Lock entity
 * @param currentUser Current User
 * @param onClick Callback function on lock icon click. Arguments: None
 */

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  isOutline: boolean
  lock?: EncounterLock | undefined
  onClick?: () => void
}

function LockIcon(
  props: Props
): JSX.Element {
  const {
    currentUser,
    isOutline,
    lock,
    onClick
  } = props
  if (isOutline) {
    return <LockOutlineIcon />
  }
  if (lockUtils.locked(lock) && lockUtils.lockOwner(lock, currentUser)) {
    // locked; current user owns lock
    const lockDate = format(
      lock && lock.creationDate || '',
      FORMAT.DATE_TIME
    )
    const msg = `Locked by you at ${lockDate}. Click to unlock`
    return (
      <Popup
        content={ msg }
        mouseEnterDelay={ 500 }
        trigger={
          <span
            onClick={ onClick }
            className="pointer"
          >
            {
              shouldRenderReskin2025
                ? (
                  <LockReveleerIcon isLocked />
                )
                : (

                  <Icon
                    name="lock"
                    size="large"
                    color="grey"
                  />
                )
            }
          </span>
        }
      />
    )
  }
  if (lockUtils.locked(lock)) {
    // locked; another user owns lock
    const lockDate = format(
      lock && lock.creationDate || '',
      FORMAT.DATE_TIME
    )
    const lockUser = lock && lock.createdByUsername
    const msg = `Locked for user ${lockUser} at ${lockDate}`
    return (
      <Popup
        content={ msg }
        mouseEnterDelay={ 500 }
        trigger={
          shouldRenderReskin2025
            ? (
              <LockReveleerIcon isLocked />
            )
            : (
              <Icon
                name="lock"
                size="large"
                color="red"
              />
            )
        }
      />
    )
  }
  // unlocked
  const msg = 'Click to lock this encounter and begin review'
  return (
    <Popup
      content={ msg }
      mouseEnterDelay={ 500 }
      trigger={
        <span
          onClick={ onClick }
          className="pointer"
        >
          {
            shouldRenderReskin2025
              ? (
                <LockReveleerIcon isLocked={ false } />
              )
              : (
                <Icon
                  name="unlock"
                  size="large"
                  color="grey"
                />
              )
          }
        </span>
      }
    />
  )
}

export default connect(mapStateToProps)(LockIcon)
